import { initAnalytics } from './analytics.js';
initAnalytics();

// Start the real city immediately and reveal only its completed first frame.
performance.mark('city-load-start');
const ready = new Promise((resolve) => window.addEventListener('cc:ready', resolve, { once: true }));
import('./main.js').then(async () => {
  await ready;
  await window.__cityStart;
  performance.mark('city-load-ready');
  performance.measure('city-launch', 'city-load-start', 'city-load-ready');
  document.body.classList.add('city-ready');
}).catch((error) => {
  console.error('Unable to open Campbell City', error);
  const fallback = document.createElement('aside');
  fallback.id = 'load-error';
  fallback.innerHTML = 'The city could not open on this device. <a href="/text">Read the site</a> or <a href="">try again</a>.';
  document.body.appendChild(fallback);
});
